export const taboolaMixins: Record<string, Partial<TaboolaProps>> = {
  on_newtab_r1_c2: {
    widgetId: 'thumbnails-f-0',
    containerName: 'taboola-homepage-r1-c2',
    mode: 'thumbnails-r-267x178-v2',
  },
  on_newtab_r1_topright: {
    widgetId: 'thumbnails-f-1x1',
    containerName: 'taboola-homepage-r1-topright',
    mode: 'thumbnails-r-267x178-v2',
  },
  on_newtab_r2_c1: {
    widgetId: 'thumbnails-f-2',
    containerName: 'taboola-homepage-r2-c1',
    mode: 'thumbnails-r-267x178-v2',
  },
  on_newtab_r3_right: {
    widgetId: 'thumbnails-f-3',
    containerName: 'taboola-homepage-r3',
    mode: 'thumbnails-r-267x178-v2',
    visibilityTimeoutInMs: 1,
  },
  on_newtab_r4_c1: {
    widgetId: 'thumbnails-f-4',
    containerName: 'taboola-homepage-r4-c1',
    mode: 'thumbnails-r-267x178-v2',
    visibilityTimeoutInMs: 1,
  },
  on_newtab_r4_right: {},
  on_newtab_endless_native: {
    widgetId: 'thumbnails-f-',
    containerName: 'taboola-homepage-d-',
    mode: 'thumbnails-r-267x178-v2',
    visibilityTimeoutInMs: 1,
  },
  on__carousel_1: {},
  on__carousel_2: {},
  on_article_hero: {},
  on_article_native_belowcontent: {},
  on_article_incontent: {},
  on_article_siderail: {},
  on_article_siderail_native: {},
  on_article_native_siderail: {
    mode: 'thumbnails-b-rr',
    containerName: 'taboola-right-rail',
    widgetId: 'Right Rail',
  },
  on_article_native_below_article_feed: {
    mode: 'alternating-thumbnails-a',
    containerName: 'taboola-below-article-thumbnails---8',
    widgetId: 'Below Article Thumbnails - 8',
  },
  on_newtab_midpage_leader: {},
  on_newtab_midpage_leader_repeated: {},
}
